import service from './request'

/**
 * 封装GET请求
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @param {object} config - axios配置
 * @returns {Promise}
 */
export function get(url, params = {}, config = {}) {
  return service({
    url,
    method: 'get',
    params,
    ...config
  })
}

/**
 * 封装POST请求 (application/json)
 * @param {string} url - 请求地址
 * @param {object} data - 请求数据
 * @param {object} config - axios配置
 * @returns {Promise}
 */
export function post(url, data = {}, config = {}) {
  return service({
    url,
    method: 'post',
    data,
    ...config
  })
}

/**
 * 封装POST请求 (application/x-www-form-urlencoded)
 * @param {string} url - 请求地址
 * @param {object} data - 请求数据
 * @param {object} config - axios配置
 * @returns {Promise}
 */
export function postForm(url, data = {}, config = {}) {
  return service({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    ...config
  })
}

/**
 * 封装PUT请求
 * @param {string} url - 请求地址
 * @param {object} data - 请求数据
 * @param {object} config - axios配置
 * @returns {Promise}
 */
export function put(url, data = {}, config = {}) {
  return service({
    url,
    method: 'put',
    data,
    ...config
  })
}

/**
 * 封装DELETE请求
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @param {object} config - axios配置
 * @returns {Promise}
 */
export function del(url, params = {}, config = {}) {
  return service({
    url,
    method: 'delete',
    params,
    ...config
  })
}

// 导出所有方法
export default {
  get,
  post,
  postForm,
  put,
  del
}